import "@/styles/global.less";
import "antd/dist/reset.css";
import { Provider } from "mobx-react";
import { Suspense } from "react";

import { ConfigProvider } from "antd";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import Router from "./routes/Router";
import stores from "./stores";
import {
  px2remTransformer,
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from "@ant-design/cssinjs";
import { App } from "antd";

dayjs.extend(utc);
dayjs.locale("zh-cn");

const px2rem = px2remTransformer({
  rootValue: 100, // 32px = 1rem; @default 16
});
function MyApp() {
  return (
    <Suspense fallback={<div></div>}>
      <StyleProvider
        transformers={[px2rem, legacyLogicalPropertiesTransformer]}
        hashPriority="high" //要把where删除掉 详细看这个链接 https://ant.design/docs/react/compatible-style-cn
      >
        <Provider {...stores}>
          <ConfigProvider>
            <App>
              <Router />
            </App>
          </ConfigProvider>
        </Provider>
      </StyleProvider>
    </Suspense>
  );
}

export default MyApp;
